import React, { PureComponent } from 'react';
import { APP_CONFIG } from '../../utils/config'
import {openUrl} from '../../utils/utils'
class LoginAlert extends PureComponent {

    handleClickClose() {
        if (this.props.clickSideMenu === false) {
            this.props.clickOverlay()
        }
        this.props.close()
    }

    loginLink() {
        //document.location.href=APP_CONFIG.logIn
        //e-Advisor 앱호환
        openUrl(APP_CONFIG.logIn, '_self', this.props.fromApp)
    }

    componentDidMount() {
        // focus advisor_layer_wrap
        document.querySelector('.layer_inner').focus()
    }

    componentWillUnmount() {
        const ele = document.querySelector('.sub_menu_inner')
        if (ele !== null) {
            document.querySelector('.sub_menu_inner').focus()
        }
    }
    render() {
        const zIndex = {
            zIndex : "103"
        }
        return (
            <div className="layer_wrap advisor_layer_wrap"  style={zIndex} >
            <div className="layer_inner" tabIndex={0} >
            <div className="layer_cont" >
                <strong className="layer_sub_tit" tabIndex={0}>{this.props.uiTexts.text_01}</strong>
                <div className="btn_area">
                    <button type="button"  className="layer_btn" onClick={() => this.loginLink()}>{this.props.uiTexts.text_24}</button>
                </div>
            </div>
            <button type="button" className="btn_close" onClick={() => this.handleClickClose()}><span className="ico_comm ico_close">레이어 닫기</span></button> 
            </div>
            </div>
        );
    }
};

export default LoginAlert;




